import { AuditInfo } from "./audit-info"

const AREA_COLORS = [
  {
    id: '1',
    color: "consulas-externas"
  },
  {
    id: '3',
    color: "hospitalizacion"
  },
  {
    id: '6',
    color: 'radiodiagnostico'
  },
  {
    id: '7',
    color: 'rehabilitacion'
  },
  {
    id: '11',
    color: 'oncologia'
  },
  {
    id: '8',
    color: 'uci'
  },
  // {
  //   id: "MEDICINA NUCLEAR",
  //   color: 'medicina-nuclear'
  // },
  {
    id: '12',
    color: 'radiologia-intervencionista'
  },
  {
    id: '9',
    color: 'urgency'
  },
  {
    id: '5',
    color: 'quirofano'
  },
  {
    id: '1',
    color: 'consultas'
  },
  // {
  //   id: 'PLANTA',
  //   color: 'panta'
  // }
  {
    id: '2',
    color: 'garantia'
  },
  {
    id: '4',
    color: 'laboratorio'
  },
  {
    id: '10',
    color: 'anatomia-patologica'
  },

]

const BILLING_ICONS = [
  {
    id: '4',
    icon: 'check-circle',
    color: '#19947F'
  },
  {
    id: '2',
    icon: 'exclamation-circle',
    color: '#FF7B4D'
  },
  {
    id: '1',
    icon: 'check-circle',
    color: '#19947F'
  },
  // {
  //   id: 'Emitida',
  //   icon: 'check-circle',
  //   color: '#19947F'
  // },
  // {
  //   id: 'Rectifica Anulada',
  //   icon: 'check-circle',
  //   color: '#19947F'
  // },
  // {
  //   id: 'Rectifica Abonada',
  //   icon: 'exclamation-circle',
  //   color: '#FF7B4D'
  // },
  // {
  //   id: 'Rectifica Anulada',
  //   icon: 'exclamation-circle',
  //   color: '#FF7B4D'
  // },
  // {
  //   id: 'Pdte. Remesar',
  //   icon: 'exclamation-circle',
  //   color: '#FF7B4D'
  // },
  {
    id: '5',
    icon: 'exclamation-circle',
    color: '#FF7B4D'
  },
  // {
  //   id: 'Pdte. Emitir',
  //   icon: 'exclamation-circle',
  //   color: '#FF7B4D'
  // },
  // {
  //   id: 'P.Cobrada',
  //   icon: 'check-circle',
  //   color: '#19947F'
  // },
  // {
  //   id: 'Abono',
  //   icon: 'check-circle',
  //   color: '#19947F'
  // },
  // {
  //   id: 'P.Abonada',
  //   icon: 'check-circle',
  //   color: '#19947F'
  // },
  // {
  //   id: 'Gest.Cobro Pdte.Cobro',
  //   icon: 'exclamation-circle',
  //   color: '#FF7B4D'
  // },
  {
    id: '3',
    icon: 'exclamation-circle',
    color: '#FF7B4D'
  },
  {
    id: '6',
    icon: 'exclamation-circle',
    color: '#FF7B4D'
  },
  {
    id: '7',
    icon: 'exclamation-circle',
    color: '#FF7B4D'
  },
  {
    id: '8',
    icon: 'exclamation-circle',
    color: '#FF7B4D'
  }


]


const COLLECTIONS_ICONS = [
  {
    id: '1',
    icon: 'exclamation-circle',
    color: '#FF7B4D'
  },
  {
    id: '2',
    icon: 'check-circle',
    color: '#19947F'

  }

]

const LIQUIDATIONS_ICONS = [
  {
    id: '1',
    icon: 'exclamation-circle',
    color: '#FF7B4D'
  },
  {
    id: '2',
    icon: 'check-circle',
    color: '#19947F'

  }

]

export const ORDERABLE_COLUMNS = [
  { id: 'area', value: 'AREA' },
  { id: 'attendanceDescription', value: 'ATTENDANCE' },
  { id: 'attendanceAmount', value: 'ATTENDANCE_AMOUNT' },
  { id: 'attendance', value: 'ATTENDANCE_DATE' },
  { id: 'attendanceNumber', value: 'ATTENDANCE_NUMBER' },
  { id: 'billing', value: 'BILLING_AMOUNT' },
  { id: 'billingNumber', value: 'BILLING_NUMBER' },
  { id: 'billingState', value: 'BILLING_STATE' },
  { id: 'center', value: 'CENTER' },
  { id: 'collectionState', value: 'COLLECTION_STATE' },
  { id: 'company', value: 'COMPANY' },
  { id: 'financierName', value: 'FINANCIER' },
  { id: 'group', value: 'GROUP' },
  { id: 'insuranceName', value: 'INSURANCE' },
  { id: 'liquidationNumber', value: 'LIQUIDATION_NUMBER' },
  { id: 'liquidationState', value: 'LIQUIDATION_STATE' },
  { id: 'patientName', value: 'PATIENT' },
  { id: 'specialtyName', value: 'SPECIALTY' }
]

export interface Remuneration {
  area: AreaModel;
  attendance: Attendance;
  // auditInfo: AuditInfo;
  billing: Billing;
  center: CenterModel;
  collection: Collection;
  company: CompanyModel;
  financier: FinancierModel;
  group: GroupModel;
  insurance: InsuranceModel;
  liquidation: Liquidation;
  patientName: string;
  // doctor: DoctorModel;
  society: SocietyModel;
  specialty: SpecialityModel;
  userId: string;
  userName: string;
  remunerationId?: number;
  medicalHistoryNumber?: string;
  unitNumber?: string;
}

export interface Attendance {
  number: string, // Nº asistencia o Nº encuentro a la que pertenece la línea de actividad
  description: string,
  date: string,
  amount: number;
}
export interface CompanyModel {
  companyId: string;
  description: string;
  color?: string;
}

export interface SpecialityModel {
  specialtyId: string;
  description: string;
  color?: string;

}
export interface SocietyModel {
  societyId: string;
  description: string;
  color?: string;
}

export interface InsuranceModel {
  insuranceId: string;
  description: string;
  color?: string;
  checked?:boolean;
}

export interface GroupModel {
  groupId: string;
  description: string;
  color?: string;
}

export interface FinancierModel {
  financierId: string;
  description: string;
  color?: string;
}
export interface Billing { // Factura de la línea de actividad
  statusId: string;
  statusName: string;
  date: string;
  number: string;
  amount: number;
  icon?: string;
  color?: string;
}
export interface Liquidation { // Liquidación
  statusId: string;
  statusName: string
  number: string;
  date: string;
  icon?: string;
  color?: string
}

export interface CommonModel {
  id: number,
  description: string
  color?: string;
}

export interface SocietyModel {
  societyId: string,
  description: string
  color?: string;
  checked?:boolean;
}

export interface DoctorModel {
  externalId: string;
  firstName: string;
  id: number;
  langId: string;
  lastName: string;
  pronounType: string;
  specialityId: number
  color?: string;
  checked?:boolean;
}

export interface CenterModel {
  centerId: string,
  description: string
  color?: string;
  checked?:boolean;
}

export interface GenericModel {
  id: string,
  description: string
  color?: string;
  checked?:boolean;
}

export interface AreaModel {
  areaId: string,
  description: string
  color?: string;
}
export interface Collection { // Cobro
  statusId: string,
  statusName: string,
  date: string;
  icon?: string;
  color?: string
}

export const getAreaColor = (id: string) => {
  const area = AREA_COLORS.find(a => a.id === id);
  if (!area) {
    return 'consultas'
  }
  return area?.color;
}

export const getBillingInfo = (id: string) => {
  const billing = BILLING_ICONS.find(a => a.id === id);
  if (!billing) {
    const aux = {
      id: 'Cobrada Total',
      icon: 'check-circle',
      color: '#19947F'
    }
    return aux;
  }
  return billing;
}
export const getCollectionInfo = (id: string) => {
  const billing = COLLECTIONS_ICONS.find(a => a.id === id);
  if (!billing) {
    const aux = {
      id: '',
      icon: 'c',
      color: ''
    }
    return aux
  }

  return billing;
}
export const getliquidationInfo = (id: string) => {
  const billing = LIQUIDATIONS_ICONS.find(a => a.id === id);
  if (!billing) {
    const aux = {
      id: 'Liquidado',
      icon: 'check-circle',
      color: '#19947F'

    }
    return aux;
  }
  return billing;
}

export interface TotalInfo {
  attendanceAmount: {
    totalAttendanceAmount: number
    byLiquidationStatus: Array<{ liquidationStatusId: string, attendanceAmount: number }>
  },
  totalBillingAmount: number;
}

export interface SummaryInfo{
  totalAttendanceAmount: number;
}
